const projects = [
	{
		name: "Imageboard",
		description:
			`After learning a bit of Express.js/Node.js and Postgres. I wanted to utilize my knowledge and bring it all together to make a fullstack app. So 
			I decided to go with PERN stack (Postgres, Express, React, Node) and make an Imageboard, something like 4chan. Learned a lot with this one.`,
		tools: ["ReactJS", "Express.js", "Node.JS", "Bootstrap", "Postgres", "Heroku"],
		urls: {
			sourceCode: "https://github.com/rronaliu/imageboard",
			appUrl: "https://fierce-shelf-55239.herokuapp.com/",
		},
	},
	{
		name: "Cocktails web app",
		description:
            `Created for fun and for training my skills with ReactJS. This is my first React web app.
             Right before my internship in Starlabs, I was working as a bartender in a cocktail bar.
             Seeing how everyone told me the best way to learn is by making something you like or would use in real life.
             I browsed through free api-s on the web and found this totally amazing api called CocktailDB and made this simple yet pretty web app,
             using the knowledge I learned while making the todo app.`,
		tools: ["ReactJS", "The CocktailDB", "Netlify", "Bootstrap"],
		urls: {
			sourceCode: "",
			appUrl: "https://koktella.netlify.app/",
		},
	},
	{
		name: "The good old Todo app (and Weather app)",
        description: `This is an app I created right after I left the internship on Starlabs. It was time to refresh my Vanilla JavaScript knowledge and see what's new.
                         I hooked up a weather API that works with geolocation and shows the weather on your location besides the to-do list which you can filter
                         through with the search option, add items to it and delete them with a click. It also saves your to-dos on local store.`,
		tools: ["HTML&CSS", "JavaScript", "Github"],
		urls: {
			sourceCode: "https://github.com/rronaliu/todoVanilla",
			appUrl: "https://rronaliu.github.io/todoVanilla/",
		},
	},
	{
		name: "Shreddit",
		description:
			"This was my first project I worked on with a team while I was interning at Starlabs. It's a social media app a mix between Twitter and Reddit.",
		tools: ["HTML&CSS", "PHP", "Laravel", "Bootstrap"],
		urls: {
			sourceCode: "https://github.com/AKralani/SHODAN---Shred",
			appUrl: "https://github.com/AKralani/SHODAN---Shred",
		},
	},
];

export default projects;